import { Container, Col, Row } from "reactstrap";
import * as TableQL from "queries/table";
import { Link } from "react-router-dom";
import { List } from "@repoflow/components/list-cursor";
import TableSchema from "@common/schema/table/public";
import * as Section from "@repoflow/components/section";
import * as appWidgets from "@shared/widgets/register";

export const Sidebar = () => null;

export const Indice = () => null;

export const Content = ({ match: { params } }) => {
  const { base } = Section.useSectionContext();

  return (
    <Container>
      <div className="mt-4"></div>

      <Row>
        <Col>
          <Link className={"btn btn-primary"} to={`${base}/new`}>
            <i className="fa fa-plus" /> Add
          </Link>
        </Col>
      </Row>

      <div className="mt-4"></div>

      <List
        path={"viewer.account.tables"}
        query={TableQL.list}
        variables={params}
        schema={TableSchema}
        target={{ $ref: "/Public/Table" }}
        // NOT optional, and the reason is easy to miss: `List` builds its own
        // schema provider from this prop, and getField() resolves a widget for
        // EVERY property of the type — not only the ones `fields` below names.
        // `/Public/Table` carries `columns` and `tags`, both arrays, and an
        // array with no `widget:` of its own resolves to `list`, which is not in
        // form-schema's built-in table. Without this the whole listing dies on
        // `widget.missing:list` and renders as a spinner that never resolves —
        // measured on br-w01, and invisible to every unit test because it is the
        // widget REGISTRY that is empty, not the data.
        widgets={appWidgets}
        empty={"No tables yet."}
        config={{
          // `rowCount` rather than the rows: the listing is the one screen that
          // must not read a table's rows, and the count is on the row precisely
          // so that it can be shown without doing so.
          "/Public/Table": {
            fields: ["title", "tableId", "rowCount", "updatedAt"],
          },
        }}
        content={({ item: { tableId } }) => (
          <>
            <Link className={"btn btn-primary"} to={`${base}/${tableId}/`}>
              Open
            </Link>{" "}
          </>
        )}
      />
    </Container>
  );
};
